const Modal = require('app/ui/Modal');
const IFrame = require('app/ui/modal/IFrame');

class RemunerationView {

    constructor(options) {
        this.initialize();
    }

    initialize() {
		this.initializeOldStatsClick();
    }

	initializeOldStatsClick(){
        $('body').on('click','.view-old-stats',function(){
            let $btn = $(this);
			let $month = $("#month").val().split('-');
			let urlStats = window.App.get('oldAdminHomeUrl') + '/sellers/listOrdersDelivery/simple&m=' + $month[1] + '_' + $month[0] + '&seller=' + $btn.data('seller');
            let modal = new IFrame({
				'modalSize': 'full',
                'url': urlStats,
            });

            modal.show();
			
			return false;
		});
	}
}

module.exports = RemunerationView;